import {
  addSuggestion as hubAdd,
  listSuggestions as hubList,
  updateSuggestion as hubUpdate,
  SUGGESTION_CATEGORIES,
  SUGGESTION_STATUSES,
} from "@hub";

const LEGACY_KEY = "dh_admin_suggestions";

function migrateLegacy() {
  const current = hubList();
  if (current.length) return;
  try {
    const legacy = JSON.parse(localStorage.getItem(LEGACY_KEY) || "[]");
    if (!Array.isArray(legacy) || !legacy.length) return;
    legacy
      .slice()
      .reverse()
      .forEach((item) => {
        const row = hubAdd({
          text: item.text,
          from_name: item.from_name,
          from_role: item.from_role,
          category: "other",
        });
        if (item.id || item.created_at) {
          hubUpdate(row.id, {
            created_at: item.created_at || row.created_at,
          });
        }
      });
  } catch {
    /* ignore broken legacy rows */
  }
}

export function listSuggestions() {
  migrateLegacy();
  return hubList();
}

export function addSuggestion({ text, from_name, from_role, from_user_id, category }) {
  return hubAdd({ text, from_name, from_role, from_user_id, category });
}

export function updateSuggestion(id, patch) {
  return hubUpdate(id, patch);
}

export function suggestionBreakdown(rows = listSuggestions()) {
  function percents(keys, pick) {
    const total = rows.length || 1;
    return keys.map((item) => {
      const count = rows.filter((row) => pick(row) === item.id).length;
      return {
        id: item.id,
        label: item.label,
        count,
        pct: Math.round((count / total) * 100),
      };
    });
  }
  return {
    total: rows.length,
    byRole: percents(
      [
        { id: "buyer", label: "Buyer" },
        { id: "seller", label: "Seller" },
        { id: "agent", label: "Agent" },
        { id: "broker", label: "Broker" },
        { id: "admin", label: "Admin" },
      ],
      (row) => row.from_role
    ),
    byCategory: percents(SUGGESTION_CATEGORIES, (row) => row.category),
    byStatus: percents(SUGGESTION_STATUSES, (row) => row.status || "new"),
  };
}

export function exportSuggestions(rows, format = "json") {
  if (format === "csv") {
    const header = ["id", "created_at", "from_role", "from_name", "category", "status", "text", "admin_notes"];
    const lines = [
      header.join(","),
      ...rows.map((row) =>
        header
          .map((key) => `"${String(row[key] ?? "").replace(/"/g, '""')}"`)
          .join(",")
      ),
    ];
    return { filename: "suggestions.csv", mime: "text/csv", body: lines.join("\n") };
  }
  return {
    filename: "suggestions.json",
    mime: "application/json",
    body: JSON.stringify(rows, null, 2),
  };
}

export { SUGGESTION_CATEGORIES, SUGGESTION_STATUSES };
